var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"title":"Eliminar ruta","size":"sm","confirm-text":_vm.isDeleting ? 'Eliminando...' : 'Eliminar ruta',"confirm-disabled":_vm.isDeleting},on:{"close":_vm.close,"confirm":_vm.deleteRoute}},[_vm._v("\n    ¿Desea eliminar la ruta "+_vm._s(_vm.route.name)+"?\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }